import React, { useEffect, useState } from 'react';
import Input from '../../../shared/forms/Input';
import ProfilePasswordInput from './ProfilePasswordInput';

import { ReactComponent as TrashIcon } from '../../../assets/icons/trash.svg';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg';

const ExtraUserCard = ({user, setUser, index, deleteUser, editable = false, onEdit, onDiscard, onSave}) => {
  let { fullName, email } = user;
  const [passwordEditable, setPasswordEditable] = useState(false);

  useEffect(() => {
    if (!editable) {
      setPasswordEditable(false);
    }
  }, [editable]);

  return (
    <div className="section-box--wide section-stack form">
      <div className="section-header__with-buttons">
        <h4 className="section-title">User {index + 2}</h4>
        {!editable && (
          <button className="btn btn-subtle"
                  type="button"
                  onClick={onEdit}>
            <EditIcon className='icon sm' />
            Edit
          </button>
        )}
      </div>

      {!editable && (
        <div className="profile-fields">
          <Input label='Full Name'
                  value={fullName || '—'}
                  onChange={() => {}}
                  disabled={true} />
          <Input label='Email'
                  value={email || '—'}
                  onChange={() => {}}
                  disabled={true} />
        </div>
      )}

      {editable && (
        <>
          <div className="profile-fields">
            <Input label='Full Name'
                    value={fullName || ''}
                    onChange={(e) => setUser({...user, fullName: e.target.value})} />
            <Input label='Email'
                    value={email}
                    onChange={(e) => setUser({...user, email: e.target.value})} />
          </div>
          <div className="form-actions">
            {deleteUser && (
              <button className="btn destructive compact"
                      type="button"
                      onClick={() => deleteUser(index)}>
                <TrashIcon className='icon sm' />
                Delete user
              </button>
            )}
            <button className="btn secondary compact"
                    type="button"
                    onClick={onDiscard}>
              Discard changes
            </button>
            <button className="btn primary compact"
                    type="button"
                    onClick={onSave}>
              Save changes
            </button>
          </div>
        </>
      )}

      <div className="profile-subsection">
        <div className="section-header__with-buttons">
          <h5 className="profile-subtitle">Password</h5>
          {!passwordEditable && (
            <button className="btn btn-subtle"
                    type="button"
                    onClick={() => setPasswordEditable(true)}>
              <EditIcon className='icon sm' />
              Change password
            </button>
          )}
        </div>
        {!passwordEditable && (
          <div className="profile-display">
            <span className="profile-display-value">••••••••••</span>
          </div>
        )}
        {passwordEditable && (
          <div className="profile-fields">
            <div className="profile-field-stack">
              <ProfilePasswordInput label='New password'
                              onChange={(e) => setUser({...user, password: e.target.value})} />
              <p className="field-help">
                8+ characters, with min one number and one uppercase character.
              </p>
            </div>
            <ProfilePasswordInput label='Confirm new password'
                            target={user.password}
                            onChange={(e) => setUser({...user, password2: e.target.value})} />
          </div>
        )}
        {passwordEditable && (
          <div className="form-actions">
            <button className="btn secondary compact"
                    type="button"
                    onClick={() => {
                      onDiscard();
                      setPasswordEditable(false);
                    }}>
              Discard changes
            </button>
            <button className="btn primary compact"
                    type="button"
                    onClick={() => {
                      onSave();
                      setPasswordEditable(false);
                    }}>
              Save changes
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ExtraUserCard;
